import { atom } from "recoil";

export const LOADING = atom<boolean>({
    key: 'boolean_loading',
    default: false
});

export const SUBSCRIPTION_SELECTED = atom<any>({
    key: 'subscription_selected',
    default: {}
});

export const CUSTOMER_SELECTED_MOBILITY = atom<any>({
    key: 'customer_selected_mobility',
    default: {}
});

export const CUSTOMER_CREATE_SELECTED_MOBILITY = atom<any>({
    key: 'customer_create_selected_mobility',
    default: {}
});

export const ORDER_SELECTED = atom<any>({
    key: 'order_selected',
    default: {}
});

export const ADD_CUSTOMER = atom<any>({
    key: 'add_customer',
    default: {}
});

export const ADD_ORGANIZATION = atom<any>({
    key: 'add_organization',
    default: {}
});

export const STEPPER_STATE = atom<any>({
    key: 'stepper_state',
    default: 0
});

export const STEPPER_FORM = atom<any>({
    key: 'stepper_form',
    default: {}
});